import {
    type Dispatch,
    type SetStateAction,
    useState,
    type MouseEvent,
} from 'react'
import { useSetAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded'
import LinkRoundedIcon from '@mui/icons-material/LinkRounded'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import GiteRoundedIcon from '@mui/icons-material/GiteRounded'

import type { YearlyFeePayerListSingle } from '@/types'
import { HISTORY_RETURN_PARAM_KEY, ROUTE_SEGMENTS } from '@/constants/general'
import { selectedCollectionPointIdAtom } from '@/state'

function YearlyFeePayerActions({
    yearlyFeePayer,
    setEdit,
    allowDetail,
}: {
    yearlyFeePayer: YearlyFeePayerListSingle,
    setEdit?: Dispatch<SetStateAction<boolean>>,
    allowDetail?: boolean,
}) {

    const navigate = useNavigate()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const setCollectionPointId = useSetAtom(selectedCollectionPointIdAtom)

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(`${window.location.origin}/${ROUTE_SEGMENTS.base}/${ROUTE_SEGMENTS.municipalityManagement
            }/${ROUTE_SEGMENTS.yearlyFeeCollection}/${yearlyFeePayer.year}/${ROUTE_SEGMENTS.yearlyFeePayers}/${yearlyFeePayer.id}`)
    }

    const handleClickCollectionPointDetail = (id: number) => {
        setCollectionPointId(id)
        navigate(`/${ROUTE_SEGMENTS.base}/${ROUTE_SEGMENTS.collectionPoint}/${ROUTE_SEGMENTS.detail}?${HISTORY_RETURN_PARAM_KEY}=true`)
    }

    return (
        <>
            <Tooltip title="Více možností">
                <IconButton
                    id="actions-button"
                    aria-label="actions"
                    aria-controls={open ? 'actions-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    color="terciary"
                    onClick={handleClick}
                    // sx={{ backgroundColor: 'editableOrange.main' }}
                >
                    <MoreVertRoundedIcon />
                </IconButton>
            </Tooltip>
            <Menu
                id="actions-menu"
                MenuListProps={{
                    'aria-labelledby': 'actions-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={(e: MouseEvent) => {
                    e?.stopPropagation()
                    handleClose()
                }}
                slotProps={{
                    paper: {
                        style: {
                            minWidth: '15ch',
                        }
                    }
                }}
            >
                {allowDetail &&
                    <MenuItem>
                        <ListItemIcon>
                            <VisibilityRoundedIcon fontSize="small" />
                        </ListItemIcon>
                        Detail poplatníka a úpravy
                    </MenuItem>
                }
                {yearlyFeePayer.household?.id &&
                    <MenuItem
                        onClick={e => {
                            e.stopPropagation()
                            handleClickCollectionPointDetail(yearlyFeePayer.household?.id)
                        }}
                    >
                        <ListItemIcon>
                            <GiteRoundedIcon fontSize="small" />
                        </ListItemIcon>
                        Detail svozového místa
                    </MenuItem>
                }
                {setEdit &&
                    <MenuItem
                        onClick={e => {
                            e.stopPropagation()
                            setEdit(true)
                            setAnchorEl(null)
                        }}
                    >
                        <ListItemIcon>
                            <EditRoundedIcon fontSize="small" />
                        </ListItemIcon>
                        Upravit
                    </MenuItem>
                }
                <MenuItem
                     onClick={e => {
                        e.stopPropagation()
                        handleCopyToClipboard()
                        setAnchorEl(null)
                    }}
                >
                    <ListItemIcon>
                        <LinkRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Zkopírovat odkaz
                </MenuItem>
            </Menu>
        </>
    )
}

export default YearlyFeePayerActions
